'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

require('slick-carousel');

var init = exports.init = function init() {
  var $quickviewEntryPoint = $('.quickview-container');
  var $quickviewButton = $('.quickview-btn');
  var $quickViewBtn = $('.js-quickview-btn');
  var $modalContainer = $('.modal-quickview');
  var quickViewSelector = '.collection-quickview-trigger';

  var $simpleQuickviewButton = $('.js-simple-quickview');
  var $simpleQuickviewClose = $('.js-simple-quickview-close');

  var $multipleQuickview = $('.js-multiple-quickview');
  var $multipleQuickviewClose = $('.js-multiple-quickview-close');
  var $multipleQuickviewEntryPoint = $('.js-multiple-quickview-entry');

  var requestSimpleQuickviewDesktop = function requestSimpleQuickviewDesktop(productHandle, variantId, $simpleQuickviewContainer) {
    var $simpleQuickviewEntryPoint = $simpleQuickviewContainer.find('.simple-quickview-entry');

    $.getJSON('/products/' + productHandle + '.js', function (product) {}).done(function (product) {

      var requestUrl = '/products/' + product.handle + '/?view=quickview-simple-contents';

      if (variantId) {
        requestUrl = requestUrl.concat('&variant=', variantId);
      }

      $.get(requestUrl, function (response) {}).done(function (response) {
        $simpleQuickviewEntryPoint.html(response);
        $simpleQuickviewContainer.addClass('is-active');
      });
    });
  };

  var requestSimpleQuickviewMobile = function requestSimpleQuickviewMobile(productHandle, variantId, productHandleArray, variantIdArray) {

    if (productHandleArray && variantIdArray) {

      var productHandles = new Array();
      var variantIds = new Array();

      productHandles = productHandleArray.split(',');
      variantIds = variantIdArray.split(',');

      var itemsProcessed = 0;

      productHandles.forEach(function (pHandle, index, array) {
        var variantId = variantIds[index];
        var requestUrl = '/products/' + pHandle + '/?view=quickview-simple-contents&variant=' + variantId;

        $.getJSON('/products/' + pHandle + '.js', function (product) {}).done(function (product) {

          $.get(requestUrl, function (response) {}).done(function (response) {
            var quickviewSlide = '<div class="multiple-quickview-slide"><span class="multiple-quickview-slide-close js-multiple-quickview-slide-close">x</span>' + response + '</div>';

            $multipleQuickviewEntryPoint.append(quickviewSlide);
            itemsProcessed++;

            if (itemsProcessed === productHandles.length) {
              $multipleQuickview.remodal().open();

              $('.js-multiple-quickview-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                centerMode: true,
                arrows: false,
                rows: 0
              });

              Flow.localize();
            }
          });
        });
      });
    } else {
      $.getJSON('/products/' + productHandle + '.js', function (product) {}).done(function (product) {

        var requestUrl = '/products/' + product.handle + '/?view=quickview-simple-contents';

        if (variantId) {
          requestUrl = requestUrl.concat('&variant=', variantId);
        }

        $.get(requestUrl, function (response) {
          $modalContainer.remodal().open();
        }).done(function (response) {
          $quickviewEntryPoint.html(response);
          Flow.localize();
        });
      });
    }
  };

  $simpleQuickviewButton.on('click', function (event) {
    $('.simple-quickview-entry').html('');

    if ($(this).hasClass('is-active')) {
      $(this).removeClass('is-active');
      $('.simple-quickview-container').removeClass('is-active');
    } else {
      $simpleQuickviewButton.removeClass('is-active');
      if (window.innerWidth > 992) {
        $(this).addClass('is-active');
      }
      var productHandle = $(this).attr('data-product-handle');
      var variantId = $(this).attr('data-variant-id');

      var productHandleArray = $(this).attr('data-product-handle-array');
      var variantIdArray = $(this).attr('data-variant-id-array');

      var $simpleQuickviewContainer = $(this).find('.simple-quickview-container');

      if (window.innerWidth < 992) {
        if ($('.js-multiple-quickview-slider').hasClass('slick-initialized')) {
          $('.js-multiple-quickview-slider').slick('unslick');
        }
        $multipleQuickviewEntryPoint.html(' ');
        requestSimpleQuickviewMobile(productHandle, variantId, productHandleArray, variantIdArray);
      } else {
        $(this).addClass('is-active');
        requestSimpleQuickviewDesktop(productHandle, variantId, $simpleQuickviewContainer);
      }
    }
  });

  $(document).on('click', '.simple-quickview-container', function (event) {
    event.stopPropagation();
  });
};